module.exports = __webpack_public_path__ + "img/56.9285fb7f.jpg";